export default {"src":"/_next/static/media/buyBackGuarantee.ae0ea6d2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};